export const Wordmark = ({ dark = false, size = 28, pulseKey = 0, className = "" }) => {
  const ink = dark ? "#F5F5F7" : "#1D1D1F";
  const block = dark ? "#5EEAD4" : "#0B8577";
  return (
    <span
      data-testid="panelo-wordmark"
      className={`font-display inline-flex items-baseline leading-none ${className}`}
      style={{ fontWeight: 700, letterSpacing: "-0.05em", fontSize: size, color: ink }}
      aria-label="panelo"
    >
      panel
      <svg viewBox="0 0 100 100" style={{ width: "0.6em", height: "0.6em", marginLeft: "0.03em" }} aria-hidden="true">
        <rect x="9" y="9" width="82" height="82" rx="24" fill="none" stroke={ink} strokeWidth="15" />
        <rect key={pulseKey} className={pulseKey ? "live-pulse" : ""} x="31" y="36" width="38" height="28" rx="8" fill={block} />
      </svg>
    </span>
  );
};

export const TvsLogo = ({ dark = false, height = 20, className = "" }) => (
  <img src={dark ? "/brand/tvs-logo-dark.svg" : "/brand/tvs-logo.svg"} alt="TVS Motor Company" draggable={false}
    style={{ height, width: "auto" }} className={className} data-testid="tvs-logo" />
);

export const BrandLockup = ({ dark = false, size = 28, pulseKey = 0, className = "" }) => (
  <span className={`inline-flex items-center ${className}`} style={{ gap: size * 0.45 }} data-testid="brand-lockup">
    <TvsLogo dark={dark} height={Math.round(size * 0.62)} />
    <span aria-hidden="true" style={{ width: 1, height: size * 0.85 }} className={dark ? "bg-white/25" : "bg-[#D2D2D7]"} />
    <Wordmark dark={dark} size={size} pulseKey={pulseKey} />
  </span>
);
